import { render } from "./Profissionais.vue?vue&type=template&id=199448c7&scoped=true"
import script from "./Profissionais.vue?vue&type=script&lang=js"
export * from "./Profissionais.vue?vue&type=script&lang=js"

import "./Profissionais.vue?vue&type=style&index=0&id=199448c7&scoped=true&lang=css"

import exportComponent from "I:\\Centrion\\projetos\\aut_fri_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-199448c7"]])

export default __exports__